import { FC } from 'react'
import { Box, Button, Typography, Modal } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'

interface BankAccountConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
}

const BankAccountConfirmationDialog: FC<BankAccountConfirmationDialogProps> = ({
  isOpen,
  onClose
}) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()

  const handleConfirmBankAccount = () => {
    navigate('/user/bank-account')
    onClose()
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby='bank-account-confirmation-title'
      aria-describedby='bank-account-confirmation-description'>
      <Box
        sx={{
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: 400,
          width: '90%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 4
        }}>
        <Typography id='bank-account-confirmation-title' variant='h6' component='h2' sx={{ mb: 2 }}>
          {formatMessage({
            id: 'bankAccountConfirmation.title',
            defaultMessage: 'Potwierdź dane bankowe'
          })}
        </Typography>
        <Typography id='bank-account-confirmation-description' sx={{ mb: 3 }}>
          {formatMessage({
            id: 'bankAccountConfirmation.message',
            defaultMessage: 'Aby usprawnić proces rozliczenia, potwierdź nam dane swojego rachunku bankowego'
          })}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
          <Button
            fullWidth
            variant='contained'
            color='primary'
            onClick={handleConfirmBankAccount}>
            {formatMessage({
              id: 'bankAccountConfirmation.confirm',
              defaultMessage: 'Potwierdź dane'
            })}
          </Button>
          <Button
            fullWidth
            variant='outlined'
            color='primary'
            onClick={onClose}>
            {formatMessage({
              id: 'bankAccountConfirmation.later',
              defaultMessage: 'Później'
            })}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default BankAccountConfirmationDialog
